import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export interface AutumnEngagedSessions {
  engagedSessions: number;
  totalEngagedSessions: number;
  sharePct: number | null;
  // Google Ads clicks (website visitors from ads) over the since-go-live
  // window. Populated only when Paid Search engaged sessions are zero; used as
  // the tile's fallback value so it shows real ad traffic instead of "0%".
  adsVisits: number;
  // "month" = current calendar month (accounts live 30+ days; matches min
  // fee billing). "go-live" = since go-live (younger accounts).
  rangeMode: "go-live" | "month";
  since: string;
  hasData: boolean;
}

export function useAutumnEngagedSessions(userId: string) {
  return useQuery<AutumnEngagedSessions>({
    queryKey: ["autumn-engaged-sessions", userId],
    queryFn: () => api.marketing.engagedSessions.get(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}
